<app-visor />
<section>
  @if(hasFormularioRespuesta){
  <div class="flex flex-column">
    <div class="mb-2">
      <CustomTitle [title]="'common.seguimiento' | translate"
        [styleClass]="'font-roboto-condensed font-18 title-blue text-uppercase font-normal'" />
    </div>
    <div class="flex">
      <app-actividad-formulario class="w-full" [options]="options"></app-actividad-formulario>
    </div>
  </div>
  }@else {
  <div class="flex">
    <div class="mb-2">
      {{ 'msg.noHayRespuestaAsociadaSeguimiento' | translate }}
    </div>
  </div>
  }
</section>